import React from 'react';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import FormWrapper from './FormWrapper';
import type { ApplicationFormContainerProps } from './types';

const ApplicationFormContainer = ({
  ReactHookFormProps,
  asyncOptions,
  isLoading,
  schema,
  onSubmit,
}: ApplicationFormContainerProps) => {
  return (
    <AsyncBox sx={{ height: '100%' }} loading={isLoading}>
      {isLoading ? (
        <div style={{ height: '100%' }} />
      ) : (
        <FormWrapper
          ReactHookFormProps={ReactHookFormProps}
          asyncOptions={asyncOptions}
          schema={schema}
          onSubmit={onSubmit}
        />
      )}
    </AsyncBox>
  );
};

export default ApplicationFormContainer;
